import { Grid } from "@mui/material"
import React from "react"
import { CurrencyField, OfficeGroupField, OfficePickupField, OfficeSwitch, SitesField, } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useOfficePickup } from "Pages/ReportsAlerts/Reports/@signals"
import { BACKEND_APIS } from "@constants"
import ReportFormSectionDivider from "Pages/ReportsAlerts/Reports/@components/FormDrawer/SectionDivider"
import OneWayRoutesField from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections/OneWays"

export default function ReportFormDrawerSitesOfficesSection() {
	return <Grid container spacing={2}>
		<Grid item xs={2}>
			<ReportFormSectionDivider title="Sites & Offices" icon="pager"/>
		</Grid>
		<Grid item xs={12}/>
		<Grid item xs={12} data-tour-id="tour-office-switch">
			<OfficeSwitch/>
		</Grid>
		<Grid item xs={5.5} data-tour-id="tour-office-field">
			<OfficesSubSection/>
		</Grid>
		<Grid item xs={6.5}/>
		<Grid item xs={4} data-tour-id="tour-site">
			<SitesField url={`${BACKEND_APIS.MASTER_DATA}/options/site-extras`}/>
		</Grid>
		<Grid item xs={1.5} data-tour-id="tour-currency">
			<CurrencyField/>
		</Grid>
		<Grid item xs={6}/>
		<Grid item xs={4} data-tour-id="tour-oneway">
			<OneWayRoutesField/>
		</Grid>
	</Grid>
}

function OfficesSubSection() {
	return useOfficePickup.value ? <OfficeGroupField/> : <OfficePickupField/>
}
